import axios from 'axios';

// env-config.js (loaded via a <script> tag in each entry page) sets
// window.process.env. Fall back to an empty object so a page that forgets that
// tag degrades to failing API calls instead of throwing here at import time,
// which would leave the whole app unmounted on a blank white screen.
const ENV = (window.process && window.process.env) || {};

// Force the API host to https so CORS preflight requests are not redirected
// (http://  or protocol-relative //  -> https://). A redirect on a preflight
// request is rejected by the browser.
function toHttps(host) {
    if (!host) return host;
    return host
        .trim()
        .replace(/^http:\/\//i, 'https://')
        .replace(/^\/\//, 'https://');
}


export const HTTP = axios.create({
    baseURL: toHttps(ENV.API_HOST_GLOBAL),
    headers: {
        Authorization: window.ApiToken ? window.ApiToken : 'Bearer '+ENV.API_TOKEN
    }
});


export default function getHttp (){
    axios.create({
    baseURL: toHttps(ENV.API_HOST_GLOBAL),
    headers: {
        Authorization: window.ApiToken ? window.ApiToken : 'Bearer '+ENV.API_TOKEN
    }
});
}



// WEBPACK FOOTER //
// ./src/core/http/http-common.js